<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
      <g transform="translate(150,150)">
        <path
          fill="#eeeeee"
          transform="scale(0.5)"
          d="M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
        />
      </g>
      <text
        :x="textPosX"
        :y="textPosY"
        fill="#f80"
        style="font-size:80px;font-style:italic;font-weight:normal;text-align:start;text-anchor:start;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;font-family:Arial"
        id="olab-text"
        xml:space="preserve"
      >
        {{ name }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: "olabprojectsvggen",
  props: ["name", "textPosX", "textPosY"]
};
</script>
